import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import Header from "../components/Header";
import Footer from "../components/Footer";
import CartDrawer from "../components/CartDrawer";
import ProductCard from "../components/ProductCard";
import api from "../lib/api";

export default function CategoryPage() {
  const { slug } = useParams();
  const [products, setProducts] = useState([]);
  const [category, setCategory] = useState(null);
  const [notFound, setNotFound] = useState(false);

  useEffect(() => {
    setNotFound(false);
    api.get(`/categories`).then((r) => {
      const cat = (r.data || []).find((c) => c.slug === slug);
      setCategory(cat || null);
      if (cat) document.title = `${cat.name} | ZEFERIUS`;
    }).catch(() => {});
    api.get(`/products?category=${slug}`)
      .then((r) => setProducts(r.data))
      .catch((e) => { if (e?.response?.status === 404) setNotFound(true); });
  }, [slug]);

  return (
    <div data-testid="category-page">
      <Header />
      <CartDrawer />
      <main className="max-w-7xl mx-auto px-6 lg:px-12 py-16 min-h-[60vh]">
        {category && (
          <div className="mb-14 animate-fade-up">
            <p className="label-caps mb-3">Categoria</p>
            <h1 className="font-display text-4xl sm:text-5xl tracking-tighter font-medium" data-testid="category-title">{category.name}</h1>
            <p className="text-zinc-400 mt-4 max-w-xl">{category.description}</p>
          </div>
        )}
        {notFound ? (
          <p className="text-zinc-500 py-20 text-center" data-testid="category-not-found">Categoria não encontrada.</p>
        ) : products.length === 0 ? (
          <p className="text-zinc-500 py-20 text-center" data-testid="category-empty">Nenhum produto nesta categoria ainda.</p>
        ) : (
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
            {products.map((p) => <ProductCard key={p.id} product={p} />)}
          </div>
        )}
      </main>
      <Footer />
    </div>
  );
}
